
export const tyreApiNm = {
  getTyre: "/tyre/getTyre",
  getTyreDetail: "/tyre/getTyreDetail",
  insertTyre: "/tyre/insertTyre",
  updateTyreColumn: "/tyre/updateTyreColumn",
  deleteTyre: "/tyre/deleteTyre",
  getTyreTransaction: "/tyre/getTyreTransaction",
  getTyreTransactionDetail: "/tyre/getTyreTransactionDetail",
  insertTyreTransaction: "/tyre/insertTyreTransaction",
  updateTyreTransactionColumn: "/tyre/updateTyreTransactionColumn",
  deleteTyreTransaction: "/tyre/deleteTyreTransaction",
  uploadTyreFile: "/tyre/uploadTyreFile",
  deleteTyreFile: "/tyre/deleteTyreFile",
  uploadTyreTransactionFile: "/tyre/uploadTyreTransactionFile",
  deleteTyreTransactionFile: "/tyre/deleteTyreTransactionFile",
  insertTyreBulk: "/tyre/insertTyreBulk",
  getTyreSize: "/tyre/getTyreSize",
  insertTyreSize: "/tyre/insertTyreSize",
  deleteTyreSize: "/tyre/deleteTyreSize",
}

export const tyreColNm = {
  TyrCd: "รหัสยาง",
  TyrBrand: "ยี่ห้อ",
  TyrModel: "รุ่น",
  TyrSzId: "ขนาด",
  PurchPr: "ราคาซื้อ",
  PurchDte: "วันที่ซื้อ",
  SupId: "ผู้จำหน่าย",
  TyrStsId: "สถานะ",
  TukId: "รถ",
  TlrId: "หางพ่วง",
  TyrPos: "ตำแหน่ง",
  Mileage: "ระยะทาง (กม.)",
  Dscp: "รายละเอียด",
  Rmk: "หมายเหตุ",
  IsActv: "Active",
}

export const tyreTransactionColNm = {
  TrnsTyp: "ประเภทรายการ",
  TrnsDte: "วันที่ทำรายการ",
  TukId: "รถ",
  TlrId: "หางพ่วง",
  TyrPos: "ตำแหน่ง",
  Mileage: "เลขไมล์ (กม.)",
  SupId: "ผู้จำหน่าย",
  UntPr: "ราคา",
  DocNo: "เลขที่เอกสาร",
  DocDte: "วันที่เอกสาร",
  Dscp: "รายละเอียด",
  Rmk: "หมายเหตุ",
}

export const tyreStsNm = {
  1: "ในสต็อก",
  2: "ติดตั้ง",
  3: "หล่อดอก",
  4: "จำหน่าย",
}

export const trnsTypNm = {
  PURCHASE: "ซื้อเข้า",
  INSTALL: "ติดตั้ง",
  REMOVE: "ถอด",
  ROTATE: "สลับ",
  RETREAD: "หล่อดอก",
  DISPOSE: "จำหน่าย",
}
